<template>
  <svg
    width="17"
    height="20"
    viewBox="0 0 17 20"
  >
    <path d="M3 4C3 3.44772 3.44772 3 4 3H12C12.5523 3 13 3.44772 13 4V6C13 6.55228 12.5523 7 12 7H4C3.44772 7 3 6.55228 3 6V4ZM4.5 5.5H11.5V4.5H4.5V5.5ZM0 2.5C0 1.11929 1.11929 0 2.5 0H14C15.3807 0 16.5 1.11929 16.5 2.5V16.75C16.5 17.1642 16.1642 17.5 15.75 17.5H1.5C1.5 18.0523 1.94772 18.5 2.5 18.5H15.75C16.1642 18.5 16.5 18.8358 16.5 19.25C16.5 19.6642 16.1642 20 15.75 20H2.5C1.11929 20 0 18.8807 0 17.5V2.5ZM1.5 16H15V2.5C15 1.94772 14.5523 1.5 14 1.5H2.5C1.94772 1.5 1.5 1.94772 1.5 2.5V16Z" />
  </svg>
</template>